import STheme from 'styles/theme'

export const FButtonTypeEnum = {
    Filled: 'filled',
    Outline: 'outline',
    Cancel: 'cancel',
    Link: 'link',
} as const

export type FButtonType = typeof FButtonTypeEnum[keyof typeof FButtonTypeEnum]

const FButtonBackgroundColors: Record<FButtonType, (theme: typeof STheme) => string> = {
    [FButtonTypeEnum.Filled]: (_) => 'buttonBg',
    [FButtonTypeEnum.Outline]: (theme) => theme.colors.backgroundColor,
    [FButtonTypeEnum.Cancel]: (theme) => theme.colors.gray150,
    [FButtonTypeEnum.Link]: (_) => null,
}

const FButtonHoverBackgroundColors: Record<FButtonType, (theme: typeof STheme) => string> = {
    [FButtonTypeEnum.Filled]: (theme) => theme.colors.primaryColor,
    [FButtonTypeEnum.Outline]: (theme) => theme.colors.hoverColor,
    [FButtonTypeEnum.Cancel]: (theme) => theme.colors.gray200,
    [FButtonTypeEnum.Link]: (_) => null,
}

const FButtonColors: Record<FButtonType, (theme: typeof STheme) => string> = {
    [FButtonTypeEnum.Filled]: (_) => 'buttonText',
    [FButtonTypeEnum.Outline]: (theme) => theme.colors.secondaryColor,
    [FButtonTypeEnum.Cancel]: (theme) => theme.colors.gray400,
    [FButtonTypeEnum.Link]: (theme) => theme.colors.secondaryColor,
}

const FButtonLoadingColors: Record<FButtonType, (theme: typeof STheme) => string> = {
    [FButtonTypeEnum.Filled]: (_) => 'buttonText',
    [FButtonTypeEnum.Outline]: (theme) => theme.colors.secondaryColor,
    [FButtonTypeEnum.Cancel]: (theme) => theme.colors.secondaryColor,
    [FButtonTypeEnum.Link]: (theme) => theme.colors.secondaryColor,
}

export const getFButtonStyle: (type: FButtonType, theme: typeof STheme) => { bg: string } = (type, theme) => {
    return { bg: FButtonBackgroundColors[type](theme) }
}

export const getFButtonHoverStyle: (type: FButtonType, theme: typeof STheme) => { bg: string } = (type, theme) => {
    return { bg: FButtonHoverBackgroundColors[type](theme) }
}

export const getFButtonTextStyle: (type: FButtonType, theme: typeof STheme) => { color: string } = (type, theme) => {
    return { color: FButtonColors[type](theme) }
}

export const getFButtonLoadingTextStyle: (type: FButtonType, theme: typeof STheme) => { color: string } = (
    type,
    theme
) => {
    return { color: FButtonLoadingColors[type](theme) }
}
